import { cn } from "@/components/ui/cn";

export interface CardProps extends React.HTMLAttributes<HTMLDivElement> {
  /** Adds hover affordance (border lift + shadow) for clickable cards. */
  interactive?: boolean;
}

/** Surface container with border, rounded corners and soft shadow. */
export function Card({
  interactive,
  className,
  children,
  ...rest
}: CardProps) {
  return (
    <div
      className={cn(
        "rounded-xl border border-border bg-surface",
        interactive &&
          "transition-all hover:-translate-y-0.5 hover:border-accent/40 hover:shadow-md",
        className
      )}
      {...rest}
    >
      {children}
    </div>
  );
}
